import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";
const ArrowRightIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={"qi-icon qi-icon-arrow-right " + className}
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g opacity="0.9">
        <g clipPath="url(#clip0_776_6156)">
          <path
            d="M3.94413 9.05336L7.58266 5.41483C7.80318 5.19431 7.80318 4.9738 7.58266 4.75328C7.36214 4.53276 7.14162 4.53276 6.92111 4.75328L3.28258 8.39181C3.06206 8.61233 3.06206 8.83285 3.28258 9.05336C3.50309 9.27388 3.72361 9.27388 3.94413 9.05336Z"
            fill="currentColor"
          />
          <path
            d="M3.28257 1.67264L6.9211 5.31117C7.14162 5.53169 7.36214 5.53169 7.58266 5.31117C7.80317 5.09066 7.80317 4.87014 7.58266 4.64962L3.94413 1.01109C3.72361 0.790574 3.50309 0.790574 3.28257 1.01109C3.06206 1.23161 3.06206 1.45213 3.28257 1.67264Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_776_6156">
          <rect
            width="9.82353"
            height="9.82353"
            rx="4.91176"
            transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0.0546875 9.94531)"
            fill="white"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(ArrowRightIcon);
